"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Post = void 0;
var _react = _interopRequireWildcard(require("react"));
var _components = require("./components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Post = exports.Post = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var actions = _ref.actions,
    body = _ref.body,
    className = _ref.className,
    options = _ref.options,
    details = _ref.details;
  return /*#__PURE__*/_react.default.createElement(_components.Container, {
    className: className,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_components.Header, null, /*#__PURE__*/_react.default.createElement(_components.Details, null, details), options && /*#__PURE__*/_react.default.createElement(_components.Options, null, options)), /*#__PURE__*/_react.default.createElement(_components.Body, null, body), actions && /*#__PURE__*/_react.default.createElement(_components.Actions, null, actions));
});
//# sourceMappingURL=Post.js.map